import './App.css';
import { useEffect, useState } from 'react';


function App() {
  const [prods, setProducers] = useState([]);
  const [selProdId, setProdId] = useState();

  useEffect(() => {

    (async () => {
      console.log('getproducers');
      const res = await fetch(`${process.env.REACT_APP_BACKENDURL}/api/GetProducers`);
      const json = await res.json();
      setProducers(json);
      if (json.length === 1) {
        setProdId(json[0].Id);
      }
    })();

    return () => { }
  }, []);

  return (
    <div className="App">
      <header className="App-header">
        <h2>RodeoGo Extras</h2>
        <h3>Canadian Cheque Print Format</h3>
      </header>
      <div className='content'>
        {prods.length > 1 &&
          <h3>Select a Producer:</h3>
        }
        <div>
          {prods.map((p) => {
            return (<div><button onClick={ev => setProdId(p.Id)}>{p.Name}</button></div>)
          })}
        </div>
        <hr />
        <Series producer={selProdId} />
      </div>
    </div>
  );
}

function Series(props) {

  const [series, setSeries] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (props.producer !== undefined) {
      setIsLoading(true);
      (async () => {
        const res = await fetch(`${process.env.REACT_APP_BACKENDURL}/api/series/${props.producer}`);
        const json = await res.json();
        console.log(json);
        setSeries(json);
        setIsLoading(false);
      })();
    }

    return () => { }

  }, [props.producer]);

  return (
    <div>
      {isLoading &&
        <progress value={null} />}
      {!isLoading && !!props.producer && series.length < 1 &&
        <h2>No Events for this Producer.</h2>}
      {series.length > 0 &&
        <h3>Select a Series:</h3>}
      {series.map((s) => {
        const refStr = `${process.env.REACT_APP_BACKENDURL}/api/pdf/${s.Id}/${s.EventDate}`;
        return (<div><a key={s.Id} target="_blank" rel="noreferrer" href={refStr}>{s.Series} - {s.EventDate}</a></div>)
      })}
    </div>
  );
}

export default App;
